export const tools = {
  bimi: {
    title: 'Look Up or Generate BIMI Record',
    text: 'Use this tool to look up a BIMI record or to create one with an approved logo.',
    link: '/resources/bimi',
    linkTitle: 'Look Up or Generate BIMI Record',
    linkText: 'Learn more',
  },
  dmarc: {
    title: 'Look Up or Generate DMARC Record',
    text: 'Use this tool to look up a DMARC record with specific policies.',
    link: '/resources/dmarc',
    linkTitle: 'Look Up or Generate DMARC Record',
    linkText: 'Learn more',
  },
  dkim: {
    title: 'Look Up DKIM Record',
    text: 'Use this tool to validate the domain and selector has a published DKIM record.',
    link: '/resources/dkim',
    linkTitle: 'Look Up or Generate DKIM Record',
    linkText: 'Learn more',
  },
  spf: {
    title: 'Look Up SPF Record',
    text: 'Use this tool to see which servers are authorized to send email for a domain.',
    link: '/resources/spf',
    linkTitle: 'Look Up or Generate SPF Record',
    linkText: 'Learn more',
  },
};

export const solutions = [
  {
    title: 'By Threat',
    text: 'Protect on-premise, cloud-based, and hybrid email services.',
    link: 'https://www.agari.com/solutions/#grid-two',
    linkText: 'Learn more',
  },
  {
    title: 'By Industry',
    text: 'Model industry-leading email security best practices.',
    link: 'https://www.agari.com/solutions/#tabs-multiple',
    linkText: 'Learn more',
  },
  {
    title: 'By Role',
    text: 'Ensure email security knowledge across the company.',
    link: 'https://www.agari.com/solutions/#grid-two',
    linkText: 'Learn more',
  }
];

export const thankYouMessageDMARC = '<p>Thank you for inquiring about your DMARC record! An email security expert will be in touch with your shortly.</p>';
export const thankYouMessageDKIM = '<p>Thank you for inquiring about your SPF record! An email security expert will be in touch with your shortly.</p>';
export const thankYouMessageBIMI = '<p>Thank you for inquiring about your BIMI record! An email security expert will be in touch with your shortly.</p>';
export const thankYouMessageSPF = '<p>Thank you for inquiring about your SPF record! An email security expert will be in touch with your shortly.</p>';

export const countries = [
  "United States",
  "Afghanistan",
  "Åland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahrain",
  "Bahamas",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia, Plurinational State of",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, the Democratic Republic of the",
  "Cook Islands",
  "Costa Rica",
  "Côte d'Ivoire",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran, Islamic Republic of",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Democratic People's Republic of",
  "Korea, Republic of",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia, the Former Yugoslav Republic of",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States of",
  "Moldova, Republic of",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine, State of",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Réunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Barthélemy",
  "Saint Helena, Ascension and Tristan da Cunha",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin (French part)",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten (Dutch part)",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan, Province of China",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela, Bolivarian Republic of",
  "Viet Nam",
  "Virgin Islands, British",
  "Virgin Islands, U.S.",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const euCountries = [
  "Austria",
  "France",
  "Malta",
  "Belgium",
  "Germany",
  "Netherlands",
  "Bulgaria",
  "Greece",
  "Poland",
  "Croatia",
  "Hungary",
  "Portugal",
  "Cyprus",
  "Ireland",
  "Romania",
  "Czech Republic",
  "Italy",
  "Slovakia",
  "Denmark",
  "Latvia",
  "Slovenia",
  "Estonia",
  "Lithuania",
  "Spain",
  "Finland",
  "Luxembourg",
  "Sweden",
];

export const gdpr = {
  'gdprEmail': {
    value: false,
    text: 'Yes, I would like to receive related content by email.',
  },
  'gdprPhone': {
    value: false,
    text: 'Yes, I would like to receive related content by phone.',
  },
  'gdprContent': {
    value: false,
    text: 'No, I do not want to receive related content.',
  }
};
